module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#podcast",
      toString: function () {
        return this.url;
      }
    }